import { CatchBoundary } from "@tanstack/react-router"
import { Loading } from "@unfiddle/ui/components/loading"
import * as React from "react"
import { ErrorComponent } from "@/ui/components/error"

export function SuspenseBoundary({
   children,
   fallback,
   errorComponent,
}: {
   children: React.ReactNode
   fallback?: React.ReactNode
   errorComponent?: React.ReactNode
}) {
   return (
      <CatchBoundary
         getResetKey={() => "reset"}
         errorComponent={
            errorComponent === null
               ? () => null
               : errorComponent
                 ? () => errorComponent
                 : (props) => (
                      <ErrorComponent
                         error={props.error}
                         reset={props.reset}
                      />
                   )
         }
      >
         <React.Suspense
            fallback={fallback === null ? null : <SuspenseFallback />}
         >
            {children}
         </React.Suspense>
      </CatchBoundary>
   )
}

export function SuspenseFallback() {
   return (
      <Loading
         size={"xl"}
         className="!absolute inset-0 m-auto -translate-y-5"
      />
   )
}
